import cn from 'classnames';
import styles from './styles.scss';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';

export interface ArrowCircleProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const ArrowCircle = ({ size = 'medium', className }: ArrowCircleProps) => (
  <div
    className={cn(
      styles.buttonContainer,
      {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
        [styles.large]: size === 'large'
      },
      className
    )}
  >
    <IconArrow className={styles.iconArrow} />
  </div>
);
